import React, { Fragment, useEffect, useState } from 'react';
import { ReactComponent as PostDetailsIcon } from 'assets/icons/post-details.svg';
import { ReactComponent as PostTimelineIcon } from 'assets/icons/post-timeline.svg';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import RightSidebar from 'components/right-sidebar';
import { ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import useEditPostContext from 'contexts/edit-post.context';
import { handleApiError } from 'utils/functions';
import { toast } from 'react-toastify';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg';
import { getPostPayload } from './util';

const EditPostContent = () => {
  const [loading, setLoading] = useState(false);
  const { disabled, editPostForm } = useEditPostContext();
  const navigate = useNavigate();
  const { postId } = useParams();
  const { pathname } = useLocation();

  const PostDetailsNav = [
    {
      title: 'Post details',
      link: `/posts/${postId}/edit/${ROUTE_KEYS.EDIT_POST_DETAILS}`,
      Icon: PostDetailsIcon
    },
    {
      title: 'Post timeline',
      link: `/posts/${postId}/edit/${ROUTE_KEYS.EDIT_POST_TIMELINE}`,
      Icon: PostTimelineIcon
    }
  ];
  const { setRightSection } = useDashboardContext();
  useEffect(() => {
    setRightSection(<RightSidebar title='Post Information' list={PostDetailsNav} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  const isDetailsPage = pathname.endsWith(`edit/${ROUTE_KEYS.EDIT_POST_DETAILS}`);
  const isTimelinePage = pathname.endsWith(`edit/${ROUTE_KEYS.EDIT_POST_TIMELINE}`);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const res = await apiService.put(`marketing/post/${postId}`, {
        data: getPostPayload(editPostForm, isDetailsPage, isTimelinePage),
        isInternal: true
      });

      toast(<ToastMessage type='success' message={res.data.message} />);
      navigate(ROUTE_KEYS.HOME);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const backLink = isDetailsPage
    ? ROUTE_KEYS.HOME
    : isTimelinePage
    ? `/posts/${postId}/edit/${ROUTE_KEYS.EDIT_POST_DETAILS}`
    : '#';

  return (
    <Fragment>
      <Outlet />
      <div className='mx-10 pb-8 max-w-[700px] flex items-center justify-between mt-12'>
        <Link to={backLink} className='p-[10px] rounded-full bg-gray-36 cursor-pointer '>
          <LeftArrow />
        </Link>

        <div className='flex items-center gap-8'>
          <Link to={ROUTE_KEYS.HOME} className='text-red-5 text-sm'>
            Cancel
          </Link>
          <Button
            onClick={handleConfirm}
            small
            variant='block'
            color='primary'
            className='text-sm'
            disabled={disabled}
            loading={loading}>
            Confirm
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default EditPostContent;
